import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";

export default [
  {
    path: LOGIN_PATH,
    layout: false,
    component: "./LoginPage",
  },
  {
    path: OIDC_CALLBACK_PATH,
    layout: false,
    component: "./OidcCallbackPage",
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "ctfDashboard",
    icon: "dashboard",
    access: "canAccessCtfTeacherWorkspace",
    component: "./DashboardPage",
  },
  {
    path: "/categories",
    name: "ctfCategories",
    icon: "appstore",
    access: "canAccessCtfTeacherWorkspace",
    component: "./CategoriesPage",
  },
  {
    path: "/challenges",
    name: "ctfChallenges",
    icon: "flag",
    access: "canAccessCtfTeacherWorkspace",
    component: "./ChallengesPage",
  },
  {
    path: "/artifact-releases",
    name: "ctfArtifactReleases",
    icon: "inbox",
    access: "canAccessCtfTeacherWorkspace",
    component: "./ArtifactReleasesPage",
  },
  {
    path: "*",
    component: "./NotFoundPage",
  },
];
